// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import firebase from "firebase/compat/app";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDdpAc1jJV6zvL5rnaYT156nEQeudvokYk",
  authDomain: "dikasir-741ce.firebaseapp.com",
  projectId: "dikasir-741ce",
  storageBucket: "dikasir-741ce.firebasestorage.app",
  messagingSenderId: "308494345772",
  appId: "1:308494345772:web:f9f9929ca0641010a41389",
  measurementId: "G-2YTMNCTMTK"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

const analytics = getAnalytics(app);

export { storage, firebase as default };
